const CHUNK_RELOAD_KEY = "etheria:chunk-reload-source";

function freshUrl(): string {
  const url = new URL(window.location.href);
  url.searchParams.set("_refresh", String(Date.now()));
  return url.toString();
}

function chunkSourceId(): string {
  const entry = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/"]');
  return entry?.src ?? window.location.pathname;
}

export function isRecoverableChunkError(error: unknown): boolean {
  const text =
    error instanceof Error
      ? `${error.name} ${error.message} ${error.stack ?? ""}`
      : String(error ?? "");

  return (
    text.includes("ChunkLoadError") ||
    text.includes("Loading chunk") ||
    text.includes("Failed to fetch dynamically imported module") ||
    text.includes("Importing a module script failed") ||
    text.includes("Unable to preload CSS") ||
    text.includes("dynamically imported module")
  );
}

export function recoverFromChunkError(error?: unknown): boolean {
  if (error !== undefined && !isRecoverableChunkError(error)) return false;

  const source = chunkSourceId();
  if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === source) return false;

  window.sessionStorage.setItem(CHUNK_RELOAD_KEY, source);
  window.setTimeout(() => window.location.replace(freshUrl()), 120);
  return true;
}

export function installChunkRecovery(): void {
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    const payload = (event as unknown as { payload?: unknown; detail?: unknown }).payload;
    recoverFromChunkError(payload ?? (event as unknown as { detail?: unknown }).detail);
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (!isRecoverableChunkError(event.reason)) return;
    event.preventDefault();
    recoverFromChunkError(event.reason);
  });

  window.addEventListener("error", (event) => {
    if (!isRecoverableChunkError(event.error ?? event.message)) return;
    event.preventDefault();
    recoverFromChunkError(event.error ?? event.message);
  });
}

export function forceFreshReload(): void {
  window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  window.location.assign(freshUrl());
}
